import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';

@Component({
    selector: 'financial-knowledge8-form',
    templateUrl: './financial-knowledge8-form.component.html',
    styleUrls: ['./financial-knowledge8-form.component.scss'],
    standalone: false
})
export class FinancialKnowledge8FormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  viewerOpen1 = false;
  viewerOpen2 = false;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.setCommand([CommandEnum.RECALCULATE_RISK_PROFIL]);
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
